import React from "react";
import EachRowCell from "./EachRowCell";

function ShowAdminView({ refreshPage, allService, allPartner, selectedView }) {
  return (
    <div className="mt-4">
     <div className="d-flex justify-content-between mobile-admin-view">
          {selectedView?.find((ele) => ele.name === "View Services") && (
            <div className="w-45 mobile-card">
              <div className="px-4 py-2 d-flex justify-content-between tableHeader border">
              <div>Services</div>
              <div>Action</div>
            </div>
            {allService?.map((ele, idx) => {
              return (
                <EachRowCell
                  key={idx}
                  item={ele}
                  currentEdit={"Service"}
                  refreshPage={refreshPage}
                />
              );
            })}
          </div>
        )}
        {selectedView?.find((ele) => ele.name === "View Profile") && (
 <div className="w-45 mobile-card">
    <div className="px-4 py-2 d-flex justify-content-between tableHeader border">
              <div>Profile</div>
              <div>Action</div>
            </div>
            {allPartner?.map((ele, idx) => {
              return (
                <EachRowCell
                  key={idx}
                  item={ele}
                  currentEdit={"Profile"}
                  refreshPage={refreshPage}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default ShowAdminView;
